/**
 * Разрешён ли путь менеджеру панели.
 * @param pathname — location.pathname
 */
export const isManagerAllowedPath = (pathname: string): boolean => {
  const normalizedPath =
    pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname
  if (
    normalizedPath === '/' ||
    normalizedPath === '/customers' ||
    normalizedPath === '/profile'
  ) {
    return true
  }
  if (normalizedPath.startsWith('/orders/')) {
    return true
  }
  return false
}
